import type { Admin } from '../types/user.types';

export function canModerateFeed(
  admin?: Pick<Admin, 'isSuper' | 'roles'> | null
) {
  return (
    !!admin &&
    (admin.isSuper ||
      admin.roles.some((role) =>
        ['OWNER', 'OPERATIONS', 'CUSTOMER_SUCCESS'].includes(role)
      ))
  );
}
